import { Accordion, Box, Button, ButtonsGroup, Card, Empty, Icon, InputSelect } from "#/atoms";
import { Contacts, HeadingIcon } from "#/molecules";
import { forwardRef, memo, useImperativeHandle } from "react";

import { CardHandle } from "../Cards.interface";
import { ContactsCardsProps } from "./Contacts.interface";
import { HPOSITION } from "@/theme";

const ContactsCard = forwardRef<CardHandle, ContactsCardsProps> (
  ({
  accordionState = 'open',
  contacts,
  isAdmin,
  isReadOnly,
  onAddCustomerContact,
  onAskToEditContact,
  onNewContact,
  onAskToRemoveContact,
  sendNotifications
}, ref) => {

  useImperativeHandle(ref, () => ({
    validate: () => {
      const isValid = contacts.length > 0;

      return { isValid: isValid, validationErrors: isValid ? [] : [ 'Please fill correct contacts data']};
    }
  }));

  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="contacts" title="Contacts" />}
        showArrow
        state={accordionState}
      >
        {contacts.length === 0 ? (
          <Empty>No contacts have been added yet.</Empty>
        ) : (
          <Contacts isReadOnly={isReadOnly} list={contacts} onAskToEditContact={onAskToEditContact} onAskToRemoveContact={onAskToRemoveContact} />
        )}
        
        { sendNotifications && <Box margin="20px 0px 10px"><InputSelect
          type="checkbox"
          checked={sendNotifications.checked}
          label="Allow order notifications"
          name="sendNotifications"
          value="sendNotifications"
          onChangeValue={sendNotifications.onChange}
          readOnly={isReadOnly}
        /></Box> }
        { !isReadOnly && <ButtonsGroup align={HPOSITION.CENTER} fullWidth margin="10px 0 0 0">
          <Button actionType='outline' onClick={onNewContact}>Create New Contact</Button>
          {onAddCustomerContact && <Button onClick={onAddCustomerContact}>
            <Icon type='plus' />
            {`Add ${isAdmin ? 'Client\'s' : 'My'} Contacts` } 
          </Button> }
        </ButtonsGroup> }
      </Accordion>
    </Card>
  );
}
);

ContactsCard.displayName = 'ContactsCard';

export default memo(ContactsCard);